import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales/use-locales";
import { useEffect, useState } from "react";

function PregnancyVenous() {
  const { t } = useTranslate();
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [vki, setVki] = useState("");

  useEffect(() => {
    const heightVal = parseFloat(height);
    const weightVal = parseFloat(weight);

    if (!isNaN(heightVal) && !isNaN(weightVal) && heightVal > 0) {
      const calculatedVki = (weightVal / ((heightVal / 100) ** 2)).toFixed(1);
      setVki(calculatedVki);
    } else {
      setVki("");
    }
  }, [height, weight]);

  const renderHeader = (label: string) => (
    <Grid xs={12} sx={{ backgroundColor: "#F4F7FE", borderBottom: "1px solid #E0E0E0" }}>
      <ByzMuiTypography >{label}</ByzMuiTypography>
    </Grid>
  );

  const renderLabelAndField = (label: string, input: React.ReactNode) => (
    <Grid container alignItems="center" justifyContent="space-between">
      <Grid xs={12} md={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
        <ByzMuiTypography>{label}</ByzMuiTypography>
      </Grid>
      <Grid xs={12} md={6}>{input}</Grid>
    </Grid>
  );

  const selectField = (label: string) =>
    renderLabelAndField(
      t(label),
      <ByzMuiSelect
        renderInput={(params) => (
          <ByzMuiTextField {...params} label={t(label)} variant="outlined" fullWidth />
        )}
        options={[]}
        fullWidth
        placeholder={t("buttons.chose")}
        label=""
      />
    );

  return (
    <Box sx={{ padding: 3, width: "100%" }}>
      <Grid container spacing={2}>
        <Grid xs={12} md={6} container direction="column" spacing={3}>
          {renderHeader(t("pregnancy-venous.title"))}

          {renderLabelAndField(t("datetime"), <ByzMuiDateTimePicker sx={{ width: "100%" }} />)}

          {selectField("pregnancy-venous.pregnancy-status")}

          {renderLabelAndField(
            t("createdby"),
            <ByzMuiTextField disabled fullWidth color="info" label={t("createdby")} variant="outlined" />
          )}

          {renderHeader(t("pregnancy-venous.risk-factors"))}

          {selectField("pregnancy-venous.history.non-surgical-vte")}
          {selectField("pregnancy-venous.history.surgical-vte")}
          {selectField("pregnancy-venous.history.thrombophilia")}
          {selectField("pregnancy-venous.history.comorbidities")}
          {selectField("pregnancy-venous.history.family-vte")}
          {selectField("pregnancy-venous.history.low-risk-thrombophilia")}
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid md={6} xs={12} sx={{ borderBottom: "1px solid #E0E0E0" }}>
              <Box sx={{ display: 'flex', gap: 4, ml: 3 }}>
                <ByzMuiTypography>*{t("pregnancy-venous.other.height")}</ByzMuiTypography>
                <ByzMuiTypography>*{t("pregnancy-venous.other.weight")}</ByzMuiTypography>
                <ByzMuiTypography>*{t("pregnancy-venous.other.bmi")}</ByzMuiTypography>
              </Box>
            </Grid>

            <Grid md={6} xs={12}>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <ByzMuiTextField
                  label={t("pregnancy-venous.other.height")}
                  value={height}
                  onChange={(e) => setHeight(e.target.value)}

                />
                <ByzMuiTextField
                  label={t("pregnancy-venous.other.weight")}
                  value={weight}
                  onChange={(e) => setWeight(e.target.value)}

                />
                <ByzMuiTextField
                  label={t("pregnancy-venous.other.bmi")}
                  value={vki}
                  disabled
                />
              </Box>
            </Grid>
          </Grid>

          {selectField("pregnancy-venous.bmi-start")}
          {selectField("pregnancy-venous.parity")}
          {selectField("pregnancy-venous.smoking")}
          {selectField("pregnancy-venous.varicose-veins")}

          {renderHeader(t("pregnancy-venous.obstetric-risks"))}

          {selectField("pregnancy-venous.obstetric.preeclampsia")}
          {selectField("pregnancy-venous.obstetric.art")}
          {selectField("pregnancy-venous.obstetric.multiple")}
          {selectField("pregnancy-venous.obstetric.cesarean-labor")}
          {selectField("pregnancy-venous.obstetric.cesarean-elective")}
          {selectField("pregnancy-venous.obstetric.stillbirth")}
          {selectField("pregnancy-venous.obstetric.preterm")}
          {selectField("pregnancy-venous.obstetric.bleeding")}
          {selectField("pregnancy-venous.obstetric.prolonged-labor")}
          {selectField("pregnancy-venous.obstetric.instrumental")}

          {renderHeader(t("pregnancy-venous.temporar"))}

          {selectField("pregnancy-venous.temporary.surgery")}
          {selectField("pregnancy-venous.temporary.hyperemesis")}
          {selectField("pregnancy-venous.temporary.ohss")}
          {selectField("pregnancy-venous.temporary.infection")}
          {selectField("pregnancy-venous.temporary.immobility")}
          {selectField("pregnancy-venous.temporary.travel")}

          {renderHeader(t("other"))}

          {renderLabelAndField(
            t("pregnancy-venous.other.note"),
            <ByzMuiTextField fullWidth color="info" label={t("pregnancy-venous.other.note")} variant="outlined" />
          )}

          {renderLabelAndField(
            t("pregnancy-venous.other.score"),
            <ByzMuiTextField fullWidth color="info" disabled label={t("pregnancy-venous.other.score")} variant="outlined" />
          )}
        </Grid>
      </Grid>
    </Box>
  );
}

export default PregnancyVenous;
